import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import styles from './Contact.module.css';

const services = [
  'Renovations & Repairs', 'Framing', 'Cladding & Siding',
  'Soffit & Flashing', 'Rainscreen & Waterproofing',
  'Hardie Board & Cement Board', 'Stucco Repairs',
  'Natural Stone', 'Finishing Carpentry', 'Other / Not Sure',
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', service: '', message: '' });
  const [sent, setSent] = useState(false);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08 });

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = e => {
    e.preventDefault();
    const sub = encodeURIComponent(`Project Inquiry: ${form.service || 'Construction'}`);
    const body = encodeURIComponent(
      `Hi Enes,\n\nName: ${form.name}\nPhone: ${form.phone}\nService: ${form.service}\n\n${form.message}\n\nReply to: ${form.email}`
    );
    window.location.href = `mailto:aussiespec.structures@gmail.com?subject=${sub}&body=${body}`;
    setSent(true);
  };

  return (
    <section id="contact" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div
          className={styles.left}
          initial={{ opacity: 0, x: -40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className={styles.label}><span className={styles.labelLine} />Contact Us</span>
          <h2 className={styles.heading}>
            Get Your <span className={styles.accent}>Free Quote</span>
          </h2>
          <p className={styles.sub}>
            Ready to start your project or have a question? Reach out to Enes directly.
            We respond fast, assess on-site, and give you a clear honest quote — no obligation.
          </p>

          <div className={styles.infoList}>
            <a href="tel:+17789912001" className={styles.infoItem}>
              <span className={styles.infoIcon}><FiPhone /></span>
              <div>
                <span className={styles.infoLabel}>Phone / Text</span>
                <span className={styles.infoVal}>(778) 991-2001</span>
              </div>
            </a>
            <a href="mailto:aussiespec.structures@gmail.com" className={styles.infoItem}>
              <span className={styles.infoIcon}><FiMail /></span>
              <div>
                <span className={styles.infoLabel}>Email</span>
                <span className={styles.infoVal}>aussiespec.structures@gmail.com</span>
              </div>
            </a>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}><FiMapPin /></span>
              <div>
                <span className={styles.infoLabel}>Service Area</span>
                {/* TODO: Add specific city/neighborhood if desired */}
                <span className={styles.infoVal}>Vancouver & Lower Mainland, BC</span>
              </div>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}><FiClock /></span>
              <div>
                <span className={styles.infoLabel}>Hours</span>
                <span className={styles.infoVal}>Mon–Sat: 7:00 AM – 6:00 PM</span>
              </div>
            </div>
          </div>

          <div className={styles.legalBox}>
            <span className={styles.legalTitle}>AussieSpec Structures</span>
            <span className={styles.legalNum}>Incorporation No: BC1585120</span>
            <span className={styles.legalSub}>Province of British Columbia, Canada</span>
          </div>
        </motion.div>

        <motion.div
          className={styles.right}
          initial={{ opacity: 0, x: 40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          {sent ? (
            <div className={styles.success}>
              <span className={styles.successIcon}>✓</span>
              <h3>Email client opened!</h3>
              <p>Complete the message and send. We will get back to you within one business day.</p>
              <button className={styles.resetBtn} onClick={() => setSent(false)}>Send Another</button>
            </div>
          ) : (
            <form className={styles.form} onSubmit={submit}>
              <h3 className={styles.formTitle}>Request a Free Estimate</h3>
              <div className={styles.row}>
                <div className={styles.group}>
                  <label>Full Name *</label>
                  <input name="name" type="text" placeholder="Your name" value={form.name} onChange={handle} required />
                </div>
                <div className={styles.group}>
                  <label>Phone Number</label>
                  <input name="phone" type="tel" placeholder="(778) 000-0000" value={form.phone} onChange={handle} />
                </div>
              </div>
              <div className={styles.group}>
                <label>Email Address *</label>
                <input name="email" type="email" placeholder="your@email.com" value={form.email} onChange={handle} required />
              </div>
              <div className={styles.group}>
                <label>Service Required *</label>
                <select name="service" value={form.service} onChange={handle} required>
                  <option value="">Select a service...</option>
                  {services.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div className={styles.group}>
                <label>Project Description *</label>
                <textarea
                  name="message"
                  rows={5}
                  placeholder="Describe your project — location, scope, any photos or measurements you have..."
                  value={form.message}
                  onChange={handle}
                  required
                />
              </div>
              <button type="submit" className={styles.submit}>
                Send Inquiry — Get Free Quote
              </button>
              <p className={styles.formNote}>We typically respond within 1 business day.</p>
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
}
